import { render } from "./BlockDividerNumberedFront.vue?vue&type=template&id=40bb7262&lang=pug"
import script from "./BlockDividerNumberedFront.vue?vue&type=script&lang=js"
export * from "./BlockDividerNumberedFront.vue?vue&type=script&lang=js"

import "./BlockDividerNumberedFront.vue?vue&type=style&index=0&id=40bb7262&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__